import axios from "axios";
import miximo from "../../router/miximo";
import country_list from "../../locales/country_list.json";
const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();

const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("lang_Mix");

if(language =='ms'){
  brwlang ='malay';
}else if(language =='ar'){
  brwlang ='arabic';
}else if(language =='el'){
  brwlang ='greek';
}else if(language =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(language =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(language =='id'){
  brwlang ='indonesian';
}else if(language =='th'){
  brwlang ='thai';
}else if(language =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(language =='en'){
  brwlang ='english';
}

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = ''

if (type == true) {
    gcid = parts[1]
} else {
    gcid = ''
}

const state = {
  live: `http://cook.grabmobi.com`,
  local: `http://[::1]/PuretechGlobalContentPortal`,
  proxyurl: `http://api.allorigins.win/get?url=`,
  //allsubcategory
  allsubcategory_Mix: {},
  //auth
  auth_Mix: "",
  //hotpicks.vue
  pageHP_Mix: {},
  //popular.vue
  pagePop_Mix: {},
  //notification.vue
  notification_Mix: {},
  //icon
  hotpickIcon_Mix: require(`../../assets/miximo/imgs/other/Hot Picks.svg`),
  popularIcon_Mix: require(`../../assets/miximo/imgs/other/Populars.svg`),
  langButton_Mix: ``,
  country_Mix: parts[0],
  host_Mix: host,
  lang_Mix: localStorage.getItem("lang_Mix"),
  // lang_Mix: brwlang,  
  type_Mix: 'browse',
  gcid_Mix: gcid,
  hpisLoad_Mix: false,
  renew_date_Mix: '',
  subscription_date_Mix: '',
  msisdn_Mix: '',
  country_name_Mix: '',
  gateway_Mix: '',
  is_unsub: '0',
  time: ''
};
// function getTime(test){
//   state.time = test
// }
const getters = {
    langButton_Mix: state => state.langButton_Mix,
    lang_Mix: state => state.lang_Mix,
    gcid_Mix: state => state.gcid_Mix,
    country_Mix: state => state.country_Mix,
    host_Mix: state => state.host_Mix,
    allsubcategory_Mix: state => state.allsubcategory_Mix,
    pageHotPicks_Mix: state => state.pageHP_Mix,
    pagePopular_Mix: state => state.pagePop_Mix,
    HotPickIcon_Mix: state => state.hotpickIcon_Mix,
    PopularIcon_Mix: state => state.popularIcon_Mix,
    notification_Mix: state => state.notification_Mix,
    auth_Mix: state => state.auth_Mix,
    hpisLoad_Mix: state => state.hpisLoad_Mix,
    renew_date_Mix: state => state.renew_date_Mix,
    subscription_date_Mix: state => state.subscription_date_Mix,
    msisdn_Mix: state => state.msisdn_Mix,
    country_name_Mix: state => state.country_name_Mix,
    gateway_Mix: state => state.gateway_Mix,
    is_unsub_Mix: state => state.is_unsub
    // time: state => state.time,
};

const actions = {
  async fetchLocale_Mix({ commit }, lang) {
    for (let [key, value] of Object.entries(country_list)) {
      if(lang == value.language){
        lang = value.language
      }else{
        //english
        lang = lang
      }
    }
    
    commit("setLanguage", lang);
  },
  async fetchTranslateButton_Mix({commit}, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if(country == key){
        let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
        <img lang="${value.language}" src="${value.flag_rec}" />
        <span lang="${value.language}">${value.button_text}</span>
        </button>`

        commit("setButton", button);
      }
    }
  },
  async fetchAllSubcategory_Mix({commit}, subcategory){
    //to get the subcategory translation
    let subcateg = await axios.get(
      `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${subcategory}&limit=1&offset=0&domain=${host}`
    );
    
    commit("setAllSubcategory", subcateg.data.data);
  },
  async fetchPageHotPicks_Mix({ commit }, file) {
    let data = file[0]

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = []

    if(data == undefined){
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
      );
    }else{
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    response.data.data.sort((a,b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    )

    // console.log(response.data.data);

    commit("setPageHotPicks", response.data.data);
  },
  async fetchPagePopular_Mix({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = await axios.get(
      `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
    );

    response.data.data.sort((a,b) =>
      // a.content_name.localeCompare(b.content_name),
      b.rating - a.rating
    )

    // console.log(response.data.data)
    commit("setPagePopular", response.data.data);
  },
  async fetchToken_Mix({ commit, dispatch }, id) {
    let auth = "";
    let check = "";

    let token = localStorage.getItem("userToken_Mix");
    let userProfile = localStorage.getItem("userProfile_Mix");

    let str = window.location.pathname;
    let path = str.split("/");
    path.pop();
    path = path.join('/');

    if(path == ''){
      path = '/home';
    }

    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }

    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkToken_Mix", auth);
      auth = auth.toLowerCase();
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (auth.match(letterNumber)) {
        check = true
      } else {
        check = false
      }
    } else {
     
      if(state.host_Mix !='sa.miximo.vip'){
        miximo.push({ name: "Login" }).catch(err => {});
      }
    }

    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };

      if (token != null) {
        localStorage.setItem("userToken_Mix", data.code);
        commit("setUserProfile", JSON.parse(userProfile));
        commit("setAuth", "loggedin");
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        let responses = await axios.post(
          `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
        );
        var response = JSON.parse(responses.data.contents);
        if (response.status == "active") {
          localStorage.setItem("userToken_Mix", data.code);
          localStorage.setItem("userProfile_Mix", responses.data.contents)
          commit("setUserProfile", response);
          commit("setAuth", "loggedin");
          miximo.push({ path: path }).catch(err => {});
        //   location.reload();
        } else if (response.status == "inactive") {
          if(data.code != undefined){
            alert(response.status.toUpperCase())
          }
          miximo.push({ name: "Login" }).catch(err => {});
        }
      }
    } else {
      //if check is false
      if(state.host_Mix !='sa.miximo.vip'){
        miximo.push({ name: "Login" }).catch(err => {});
      }
      
    }
  },
  async getDomain_Mix({ commit }, host){
    let response = await axios.get(`${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`);

    let dom= response.data.data
    dom = dom.filter(item =>{
      return item.domain == host;
    })

    let domain = ""

    if(dom != ""){
      domain = dom[0].is_unsub;

      if(dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id)
    }else{
      domain = '0'
    }
    commit("setUnsubButton", domain);
  },
  async checkToken_Mix({ commit }, auth) {
    var letterNumber = /^[0-9a-zA-Z]+$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subContent_Mix({ commit }, file) {
    let token = localStorage.getItem("userToken_Mix");
    let lang = localStorage.getItem("lang_Mix");
    let alert_pop = "";
    
    let alert_lang = require(`../../locales/miximo/${lang}.json`);
    alert_pop = alert_lang.not_subs;
    if (token != null) {
      if (file[1] != 'application/x-zip-compressed') {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_Mix,
          product: 'miximo',
          content_id: file[2],
          type: "download"
        })
        window.location.href = file[0];
        // window.open(file[0], "download");
      } else {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_Mix,
          product: 'miximo',
          content_id: file[2],
          type: "play"
        })

        window.open(file[0], "_blank");
      }
    } else {
      alert(alert_pop);

      setTimeout(() => {
        miximo.push({ name: "Login" }).catch(err => {});
      }, 1000);
    }
  },
  async loginMix({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_Mix({ commit }) {
    let notify =[]
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if(w != 0){
      date = date + 10
    }
    
    let res = await axios.get(
      `${state.live}/api/contents/newcontents_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=${host}`
    );

    let data = res.data.data;

    let noti = data.map(noti => {
      noti.titleSub_english = noti.subcategory;
      if (noti.subcategory_translate != null) {
        let sub_trans = JSON.parse(noti.subcategory_translate);
        if (sub_trans != null) {
          let trans_len = Object.keys(sub_trans).length;
          let trans_arr = Object.keys(sub_trans);

          if (sub_trans != null || sub_icon != null) {
            for (let i = 0; i < trans_len; i++) {
              noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
            }
          }
        }
      }
      return noti;
    });

    if(w == 0){
      //name ascending
      noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
    }else{
      //name descending
      noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
    }

    notify = noti.slice(0,5);

    commit("setNotification", notify);
  },
  async logout_Mix({commit}, is_unsub){
    if(is_unsub != '0'){
      let token = localStorage.getItem("userToken_Mix")
      let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_name_Mix}/${state.gateway_Mix}/unsub.php?code=${token}&msisdn=${state.msisdn_Mix}`));
      removeStorage()
      console.log(response)
      var response = JSON.parse(responses.data.contents); 
      if(responses.data.contents == 'success' || response.status =='success'){
        location.reload();
      }
      setTimeout(() => {
        location.reload();
      }, 0);
    }else{
      removeStorage();
    }

    function removeStorage(){
      localStorage.removeItem("userProfile_Mix");
      localStorage.removeItem("userToken_Mix");
      localStorage.removeItem("logged-in");
    } 
    
  }
};

const mutations = {
  setPageHotPicks: (state, response) => (state.pageHP_Mix = response),
  setPagePopular: (state, response) => (state.pagePop_Mix = response),
  setNotification: (state, response) => (state.notification_Mix = response),
  setAuth: (state, response) => (state.auth_Mix = response),
  setButton: (state, response) => (state.langButton_Mix = response),
  setLanguage: (state, response) => (state.lang_Mix = response),
  setAllSubcategory: (state, response) => (state.allsubcategory_Mix = response),
  setUserProfile: (state, response) => (
    state.renew_date_Mix = response.next_renew_date,
    state.subscription_date_Mix = response.subscription_date,
    state.msisdn_Mix = response.msisdn,
    state.country_name_Mix = response.country_code,
    state.gateway_Mix = response.gateway_code
  ),
  setGatewayID: (state, response) =>(
    state.gcid_Mix = response
  ),
  setUnsubButton: (state, response) => (
    state.is_unsub = response
  )
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/miximo-store.js